import { render } from "./ListTrashReflectionSubKomunitasView.vue?vue&type=template&id=b838d982"
import script from "./ListTrashReflectionSubKomunitasView.vue?vue&type=script&lang=js"
export * from "./ListTrashReflectionSubKomunitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__